import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import Tooltip from 'components/application/Tooltip';

const statusClassNames = {
  approaching: 'tw-bg-amber-400',
  notImmediate: 'tw-bg-green-400',
  passed: 'tw-bg-red-500',
};

export default function ReviewStatusIndicator({ status, variant }) {
  const { t: i18nT } = useTranslation('components', {
    keyPrefix: 'contentRegister.components.ReviewStatusIndicator',
  });

  if (status === 'noReviewDate') return null;

  return (
    <Tooltip
      placement='top'
      tooltip={i18nT(`${variant}.${status}`)}
      trigger='hover'
    >
      <div
        className={classNames(
          'tw-h-2.5 tw-w-2.5 tw-rounded-full',
          statusClassNames[status],
        )}
      />
    </Tooltip>
  );
}

ReviewStatusIndicator.propTypes = {
  status: PropTypes.oneOf([
    'approaching',
    'noReviewDate',
    'notImmediate',
    'passed',
  ]).isRequired,
  variant: PropTypes.oneOf(['category', 'riskAssessment']).isRequired,
};
